module.exports = {
  footerText: 'PolynomTech © 2020',
}
